import { render, staticRenderFns } from "./SupportDemandList.vue?vue&type=template&id=3c4bca8a"
import script from "./SupportDemandList.vue?vue&type=script&lang=js"
export * from "./SupportDemandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports